import React, { Component } from 'react';
import Helmet from "react-helmet";

import Bets from '../../components/account/betsPeriod';

export default  class BetsPage extends Component { 
	
	render() {
			return(
				<div className="account-index">
					<Helmet>
						<title>ИРМ - Ваши ставки</title>
					</Helmet>
					<Bets />
				</div> 
			)
	}
}
 


// WEBPACK FOOTER //
// ./src/routes/account/bets.js